import React from "react";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "./App.css";

import AccessbilityBar from "./components/template/AccessibilityBar";
import Header from "./components/template/Header";
import Routes from "./routes";
import Footer from "./components/template/Footer";
import BtnToTop from "./components/template/BtnToTop";

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <ToastContainer />
        <AccessbilityBar />
        <Header />
        <Routes />
        <Footer />
        <BtnToTop />
      </div>
    </BrowserRouter>
  );
}

export default App;
